// PDFs in public folder
export const coverageLevelUpdateForm = "https://www.hsabank.com/hsabank/-/media/files/coverage-level-update-form";

export const transactionDisputeForm = "https://www.hsabank.com/hsabank/-/media/files/transaction-dispute-form";

export const hsaContributionForm = "https://www.hsabank.com/~/media/Files/contribution_form ";

export const hsaContributionReversalForm = "https://www.hsabank.com/hsabank/-/media/files/hsa-contribution-reversal-form";

export const hsaDesignationOfBeneficiaryForm = "https://hsabank.bynder.com/m/db991b1a8eb5705b/original/HSA-Designation-of-Beneficiary-Form.pdf";

export const hsaDirectTransferForm = "https://www.hsabank.com/~/media/Files/transfer_rollover";

export const hsaDistributionReversalForm = "https://hsabank.bynder.com/m/ce10b74eb808459b/original/HSA-Distribution-Reversal-Form-check.pdf";

export const hsaExcessContributionRemovalForm = "http://www.hsabank.com/~/media/Files/excess_removal ";

export const hsaRolloverFrom = "http://www.hsabank.com/~/media/Files/CDH/Forms/hsa-rollover-request-form";

export const hsaTaxCorrectionFrom = "http://www.hsabank.com/~/media/Files/CYC_forms/cyc-hsa-tax-correction-form";

export const hsaVerificationForm = "http://www.hsabank.com/~/media/Files/CDH/Forms/health-savings-account-verification-form";

export const hsaWithdrawalForm = "https://www.hsabank.com/~/media/Files/withdrawal_form";

export const iraToHsaTransferForm = "https://www.hsabank.com/~/media/Files/ira_transfer";

export const nameChangeRequestForm = "https://www.hsabank.com/hsabank/~/media/files/CDH/Forms/name_change_request_form";

export const transferOutInstructions = "https://www.hsabank.com/~/media/Files/CDH/transfer-out-instructions";

export const domain = "hsabank.com";
